import { useQuery } from '@tanstack/react-query';
import api, { DocumentSignEnvelopeDetailResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseEnvelopeReturn {
  envelope: DocumentSignEnvelopeDetailResponse | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useEnvelope(envelopeId: string | null | undefined): UseEnvelopeReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.documentSign.envelope(envelopeId ?? '__none__'),
    queryFn: () => api.getDocumentSignEnvelope(envelopeId as string),
    enabled: !!envelopeId,
  });

  return {
    envelope: data?.envelope ?? null,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load envelope' : null,
    refresh: () => {
      refetch();
    },
  };
}
